module.exports = __webpack_public_path__ + "static/img/1819.8fc289b.png";